const getModuleState = (state) => state.sliders;


export const getFilmsGlobalState = (state) => getModuleState(state);
export const getHomeSliders = (state) => getModuleState(state).homeSliders;
export const getHomeSliderById = (state) => getModuleState(state).homeSliderById;
